module.exports = __webpack_public_path__ + "static/media/icon-visit-note.294ddf9d.svg";